<template>
    <v-container grid-list-xs>
        <v-form>
            <v-card>
                <v-card-title primary-title class="text-uppercase">
                    <v-btn
                        icon
                        @click="
                            $inertia.visit(
                                $route(
                                    'tenant.reservations.index',
                                    $page.props.tenant.id
                                )
                            )
                        "
                    >
                        <v-icon>mdi-arrow-left</v-icon>
                    </v-btn>
                    {{ $t("title.edit_reservation") }}
                </v-card-title>
                <v-divider></v-divider>
                <v-card-text>
                    <v-layout row wrap>
                        <v-flex xs12>
                            <v-subheader class="pa-0">
                                <strong>{{ $t("Customer") }}</strong>
                            </v-subheader>
                            <v-layout row wrap class="blue-grey lighten-5 pa-5">
                                <v-flex xs12 md6>
                                    <ValidationProvider
                                        name="customer_first_name"
                                        rules=""
                                        v-slot="{ errors }"
                                    >
                                        <v-text-field
                                            v-model="item.customer_first_name"
                                            :label="$__('First Name')"
                                            prepend-inner-icon="mdi-account"
                                            dense
                                            :error-messages="errors"
                                        >
                                        </v-text-field>
                                    </ValidationProvider>
                                </v-flex>
                                <v-flex xs12 md6>
                                    <ValidationProvider
                                        name="customer_last_name"
                                        rules=""
                                        v-slot="{ errors }"
                                    >
                                        <v-text-field
                                            v-model="item.customer_last_name"
                                            :label="$__('Last Name')"
                                            prepend-inner-icon="mdi-account"
                                            dense
                                            :error-messages="errors"
                                        >
                                        </v-text-field>
                                    </ValidationProvider>
                                </v-flex>
                                <v-flex xs12 md12>
                                    <ValidationProvider
                                        name="customer_email"
                                        rules="email"
                                        v-slot="{ errors }"
                                    >
                                        <v-text-field
                                            v-model="item.customer_email"
                                            :label="$__('Email')"
                                            prepend-inner-icon="mdi-email"
                                            dense
                                            :error-messages="errors"
                                        >
                                        </v-text-field>
                                    </ValidationProvider>
                                </v-flex>
                                <v-flex xs12 md12>
                                    <ValidationProvider
                                        name="customer_phone"
                                        rules="phone"
                                        v-slot="{ errors }"
                                    >
                                        <vue-tel-input-vuetify
                                            v-model="item.customer_phone"
                                            mode="international"
                                            :preferredCountries="['KH']"
                                            :placeholder="null"
                                            :label="$__('label.phone_number')"
                                            validate-on-blur
                                            required
                                            :error-messages="errors"
                                        ></vue-tel-input-vuetify>
                                    </ValidationProvider>
                                </v-flex>
                            </v-layout>
                        </v-flex>
                        <v-subheader class="pa-0">
                            <strong>{{ $t("Outlet") }}</strong>
                        </v-subheader>
                        <v-flex xs12 md12>
                            {{ $t("Outlet") }}:
                            <strong>
                                {{ detail.outlet_name }}
                            </strong>
                        </v-flex>
                        <v-flex xs12>
                            <form-reservation
                                v-model="item"
                                :outlets="[]"
                                :data="data"
                                :statuses="statuses"
                                :adults="adults"
                                :children="children"
                                :tables="tables"
                            ></form-reservation>
                        </v-flex>
                    </v-layout>
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                        color="primary"
                        @click.native="submit()"
                        :loading="item.processing"
                    >
                        <v-icon left>mdi-content-save</v-icon>
                        {{ $t("Save") }}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-form>
    </v-container>
</template>
<script>
    export default {
        props: ["data", "detail", "statuses", "adults", "children", "tables"],
        data() {
            return {
                item: this.$inertia.form({
                    uuid: this.data.uuid,
                    customer_id: this.data.customer_id,
                    customer_first_name: this.data.customer_first_name,
                    customer_last_name: this.data.customer_last_name,
                    customer_email: this.data.customer_email,
                    customer_phone: this.data.customer_phone,
                    outlet_id: this.data.outlet_id,
                    adults: this.data.adults,
                    children: this.data.children,
                    date: this.data.date,
                    time: this.data.time,
                    description: this.data.description,
                    status: this.data.status,
                    options: this.data.options,
                }),
            };
        },
        methods: {
            submit() {
                this.item.put(
                    this.$route("tenant.reservations.update", {
                        tenant: this.$page.props.tenant.id,
                        reservation: this.item.uuid,
                    })
                );
            },
        },
    };
</script>